export type OrderDesignStatus =
  | "DRAFT"
  | "REQUESTED"
  | "OPENED"
  | "VALIDATED"
  | "AUTOMATICALLY_VALIDATED"
  | "REJECTED";

export const OrderDesignStatusEnum: Record<
  OrderDesignStatus,
  OrderDesignStatus
> = {
  DRAFT: "DRAFT",
  REQUESTED: "REQUESTED",
  OPENED: "OPENED",
  VALIDATED: "VALIDATED",
  AUTOMATICALLY_VALIDATED: "AUTOMATICALLY_VALIDATED",
  REJECTED: "REJECTED",
};

export interface OrderDesignHistoryRecord {
  id: string;
  status: OrderDesignStatus;
  changedAt: string;
}

export interface OrderDesignComment {
  id: string;
  comment: string;
  translatedComment?: string;
  attachments: Array<{
    filename: string;
    url: string;
  }>;
  createdAt: string;
  author: {
    firstName: string;
    lastName: string;
  };
}

export interface OrderDesign {
  id: string;
  orderId: string;
  status: OrderDesignStatus;
  filenames: string[];
  createdAt: string;
  updatedAt: string;
  history: OrderDesignHistoryRecord[];
  comments: OrderDesignComment[];
}
